import { render, staticRenderFns } from "./SecretariaVirtual.vue?vue&type=template&id=3ee05dca"
import script from "./SecretariaVirtual.vue?vue&type=script&lang=js"
export * from "./SecretariaVirtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports